<template>
  <div class="p-2 md:p-0">
    <dl
      v-if="emails.length > 0"
      class="border rounded uk-description-list uk-description-list-divider"
    >
      <div class="p-2 border-b" v-for="email in emails">
        <dt class="text-xs font-light">
          {{ $root.getVal(128, email.template_id) }}
        </dt>

        <dd style="white-space: pre-wrap" v-html="safeHtml(email.body)"></dd>
        <div style="clear: both"></div>
        <span style="float: right; font-size: 9px">
          <vk-icon icon="user" ratio="0.5" />
          {{ $root.getVal(15, email.agent_id) }} /
          <small style="font-size: 9px">{{ email.created_at }}</small>
        </span>
        <div style="clear: both"></div>
      </div>
    </dl>

    <form @submit.prevent="saveForm()">
      <div class="uk-margin">
        <label>Gönderilecek Şablon</label>
        <select v-model="form.template_id" class="uk-select">
          <option
            v-for="template in $root.cache.getOptions[128]"
            :value="template.value"
            >{{ template.label }}
          </option>
        </select>
      </div>

      <div class="uk-margin">
        <label>Gönderilecek Zaman</label>
        <select
          v-model="formMinute"
          @change="minuteConvert(formMinute)"
          class="uk-select"
        >
          <option value="0">Şimdi </option>
          <option value="15">15 dakika sonra</option>
          <option value="30">30 dakika sonra</option>
          <option value="60">1 saat sonra</option>
          <option :value="3 * 60">3 saat sonra</option>
          <option :value="24 * 60">24 saat sonra</option>
          <option :value="7 * 60 * 24">1 hafta sonra </option> 
          <option :value="14 * 60 * 24">2 hafta sonra </option>
          <option :value="30 * 60 * 24">1 ay sonra </option> 
        </select>
      </div>
      <span class="text-xs">(5 er dakikalık periyotlar ile biriken mailler gönderiliyor)</span>

      <div class="uk-margin" v-if="formMinute == 'c'">
            <datepicker
              :input="{ name: 'datepicker' }"
              :form="{ type: 1 }"
              @changed="(re) => setDatepickerNote(re)"
            />
          </div>

      <div class="uk-margin">
        <savebutton action="saveForm" title="Gönder" />
      </div>
    </form>
  </div>
</template>
<script>
import HttpService from "../../services/http";

import dateVue from "../Ui/Search/datetime.vue";
import moment from "moment";
import EventBus from "../Ui/EventBus";
import safeHtml from "../../services/safeHtml";
export default {
  props: {
    field: String,
    table: String,
    id: String,
    selectedStatus: String,
  },
  components:{
    datepicker: dateVue,
  },
  data() {
    return {
      form: {},
      emails: [],
      formMinute: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // Kaçışlanmış metin + özniteliksiz basit biçimlendirme (bkz. services/safeHtml).
    safeHtml,
    minuteConvert(e) {
      this.form.start = moment()
        .add(e, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    setDatepicker(e) {
      this.form.start = e.value;
      this.form.end = e.value;

      this.$forceUpdate();
    },
    setDatepickerNote(e) {
      console.log(e,"e");
      this.form.start = e.value;
      this.form.end = e.value;

      this.$forceUpdate();
    },

    getData() {
      this.form.lead_id = this.id;

      HttpService.getData({
        table: "lead_emails",
        filters: [
          {
            name: "lead_id",
            value: this.id,
            type: 1,
          },
        ],
        id: this.id,
      }).then((response) => {
        this.emails = response.data.results;
      });
    },
    saveForm() {
      this.$parent.$emit("loading", true);
      EventBus.$emit("loadingStatus", { action: "saveForm", loading: true });

      HttpService.processEmail(this.form)
        .then((resp) => {
          console.log(resp.data, resp.data.success, "success data ");
          if (resp.data.success) {
            EventBus.$emit("loadingStatus", {
              action: "saveForm",
              loading: false,
              success: true,
            });

            this.edit = false;
            this.form = {};
            document.querySelector(".uk-textarea").innerHTML = "";
            this.getData();
            this.$root.successMessage("İşlem başarıyla kaydedildi");
            this.$emit("after", "success");
          } else {
            EventBus.$emit("loadingStatus", {
              action: "saveForm",
              loading: false,
              success: false,
            });
          }
        })
        .catch(() => {
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
          EventBus.$emit("loadingStatus", {
            action: "saveForm",
            loading: false,
            success: false,
          });
        })
        .finally(() => {
          this.$parent.$emit("loading", false);
        });
    },
  },
};
</script>
